import axios from 'axios';
import { URLEndpoints } from '../../constants/urlConstants';

const BASE_URL = process.env.REACT_APP_NODEJS_SERVER_URL;

const authHeaders = () => ({
  headers: {
    accessToken: localStorage.getItem('accessToken') || ''
  }
});

export const generatePresentationApi = async (payload) => {
  try {
    const res = await axios.post(
      `${BASE_URL}/${URLEndpoints.generateEmailPresentation}`,
      payload,
      authHeaders()
    );
    return res;
  } catch (error) {
    console.log(error);
  }
};

export const fetchPresentationDetails = async (id) => {
  try {
    const res = await axios.get(
      `${BASE_URL}/${URLEndpoints.presentation}/${id}`,
      authHeaders()
    );
    return res?.data;
  } catch (error) {
    console.log(error);
    throw error;
  }
};

export const postComment = async (payload) => {
  try {
    const res = await axios.post(
      `${BASE_URL}/${URLEndpoints.presentationComment}`,
      payload,
      authHeaders()
    );
    return res?.data;
  } catch (error) {
    console.log(error);
    throw error;
  }
};

export const listPresentationsByOrder = async (orderId) => {
  const url = `${process.env.REACT_APP_NODEJS_SERVER_URL}/presentation/by-order/${orderId}?limit=100`;
  const { data } = await axios.get(url, authHeaders());
  return data?.presentations ?? [];
};

export const sendPresentationEmail = async (presentationId, instanceUniqueId, email) => {
  const response = await axios.post(
    `${BASE_URL}/presentation/${presentationId}/send-mail`,
    { instanceUniqueId, email },
    authHeaders()
  );
  return response.data;
};

export const getProductComments = async (presentationId, productId) => {
  if (!presentationId || !productId) {
    return { comments: [] };
  }
  try {
    const response = await axios.get(
      `${BASE_URL}/presentation-comment/`,
      {
        ...authHeaders(),
        params: {
          presentationId,
          productId
        }
      }
    );
    return response.data;
  } catch (error) {
    throw new Error('Error fetching comments');
  }
};

export const editComment = async (commentId, updatedComment) => {
  try {
    const response = await axios.put(
      `${BASE_URL}/presentation-comment/${commentId}`,
      { comment: updatedComment },
      authHeaders()
    );
    return response.data;
  } catch (error) {
    console.error('Error editing comment:', error);
    throw error;
  }
};

// Delete comment function
export const deleteComment = async (commentId) => {
  try {
    const response = await axios.delete(
      `${BASE_URL}/presentation-comment/${commentId}`,
      authHeaders()
    );
    return response.data;
  } catch (error) {
    console.error('Error deleting comment:', error);
    throw error;
  }
};

// Revisions of one presentation, not other presentations on the project.
export const listPresentationRevisions = async (orderId, presentationId) => {
  const url = `${BASE_URL}/orders/${orderId}/document-snapshots/presentation/${presentationId}`;
  const { data } = await axios.get(url, authHeaders());
  return data?.snapshots ?? [];
};
